export const DefaultOnScrollOptions = {
  threshold: 25,
  batchSize: 50,
  debounceOnScrollInterval: 300,
};
